export default __webpack_public_path__ + "static/media/Mode_Print.d0fba53c.svg";